module.exports = __webpack_public_path__ + "images/emoji/sweat_smile.2caece714e4230b7804e.png";